import { extendTheme } from '@chakra-ui/react';
import GlobalConstants from '../../constants/GlobalConstants';

// Note : At the moment we are add constant colors. Will replace it with equivalent graphql query.

const getTheme = () => {
    const { primaryColor, secondaryColor, tertiaryColor, isDarkTheme, fontFamily, highlighted_section, inactive } = GlobalConstants.getInstance().getConstants();
    const commonWhite = '#FFFFFF'
    const commonBlack = '#0D0D0D'
    const independence = '#474D66'
    const brightGrey = '#8F95B2'
    const tertiaryLight = '#A5B9CB'
    const tertiaryHover = '#0C4472'
    const cultured = '#F4F6FA'
    const yankeesBlue = '#222739'
    const yaleBlue = '#0F558F'
    const carolinaBlue = '#5499D1'
    const ebonyClay = '#2E3246'
    const athensGrey = '#E6E8F0'
    const mineShaft = '#282828'
    const darkBlueGrey = '#696F8C'
    const beauBlue = '#B7D7EA'
    const blueSapphire = '#266183'
    const cetaceanBlue = '#101840'
    const lavenderGrey = '#C1C4D6'
    const sweetBrown = '#A73636'
    const ghostWhite = '#F9FAFC'
    const shadowBlack = '#00000099'
    const shadowWhite = '#FFFFFF99'
    const aliceBlue = '#E2EFF6'
    const aliceGreen = '#153444'
    const gainsBoro = '#D8DAE5'
    const coolGrey = '#8F95B2'
    const faluRed = '#8B1515'
    const melon = '#F4B6B6'
    const ateneoBlue = '#003A70'
    const pomonaGreen = '#1e4f2c'
    const chineseWhite = '#d4edda'
    const teaGreen = '#c3e6cb'
    const polyPomonaGreen = '#155724'
    const metallicSeaWeed = '#117A8B'
    const darkSilver = '#707070'
    const lightTertiaryColor = `${tertiaryColor}e6`
    const disabledTertiaryColor = `${tertiaryColor}b3`

    return extendTheme({
        colors: {
            brand: {
                primary: primaryColor,
                secondary: secondaryColor,
                tertiary: tertiaryColor,
                highlightedSection: highlighted_section,
                inactive: inactive,
                lightTertiary: lightTertiaryColor,
                disabledTertiary: disabledTertiaryColor,
            },
            common: {
                white: commonWhite,
                black: commonBlack,
                gWhite: ghostWhite,
                borderGrey: darkBlueGrey,
                grey05: lavenderGrey,
                brown: sweetBrown,
                hoverBlue: ateneoBlue,
            },
            background: {
                main: isDarkTheme ? commonBlack : secondaryColor,
                modal: isDarkTheme ? commonBlack : commonWhite,
                secondary: isDarkTheme ? ebonyClay : cultured,
                icon: isDarkTheme ? blueSapphire : beauBlue,
                shadow: isDarkTheme ? shadowBlack : shadowWhite,
                button: isDarkTheme ? aliceGreen : aliceBlue,
                error: isDarkTheme ? faluRed : melon,
                successMessage: chineseWhite,
            },
            text: {
                grey: isDarkTheme ? cultured : independence,
                white: isDarkTheme ? commonWhite : commonWhite,
                error: isDarkTheme ? commonWhite : sweetBrown,
                green: polyPomonaGreen,
                footerLink: metallicSeaWeed,
                silver: darkSilver,
            },
            border: {
                grey: isDarkTheme ? yankeesBlue : tertiaryLight,
                secondaryGrey: coolGrey,
                green: pomonaGreen,
                successMessage: teaGreen,
            },
            button: {
                blue: isDarkTheme ? carolinaBlue : yaleBlue,
                hover: isDarkTheme ? carolinaBlue : tertiaryHover,
            },
            table: {
                primary: isDarkTheme ? ebonyClay : ghostWhite,
                secondary: isDarkTheme ? mineShaft : athensGrey,
                tertiary: isDarkTheme ? mineShaft : brightGrey,
                quaternary: isDarkTheme ? commonBlack : commonWhite,
            },
            tabsHeader: {
                active: isDarkTheme ? secondaryColor : gainsBoro,
                inActive: isDarkTheme ? yankeesBlue : brightGrey,
            },
            imageBackground: {
                main: isDarkTheme ? ghostWhite : cetaceanBlue,
            },
            error: {
                main: '#A73636'
            },
            success: {
                main: '#317159'
            },
            input: {
                border: darkBlueGrey,
                placeholder: coolGrey,
            },
        },
        breakpoints: {
            sm: '37.5rem',
            md: '56.5625rem',
            lg: '80rem',
            xl: '90rem',
        },
        textStyles: {
            h1: {
                fontFamily,
                fontSize: { base: '2rem', sm: '2.125rem', lg: '2.25rem' },
                fontWeight: 600,
                lineHeight: { base: '2.25rem', sm: '2.375rem', lg: '2.5rem' },
            },
            h2: {
                fontFamily,
                fontSize: { base: '1.75rem', sm: '1.875rem', lg: '2rem' },
                fontWeight: 600,
                lineHeight: { base: '2rem', sm: '2.125rem', lg: '2.25rem' },
            },
            h3: {
                fontFamily,
                fontSize: { base: '1.5rem', lg: '1.625rem' },
                fontWeight: 600,
                lineHeight: { base: '1.875rem', lg: '2rem' },
            },
            h4: {
                fontFamily,
                fontSize: { base: '1.25rem' },
                fontWeight: 400,
                lineHeight: { base: '1.5rem' },
            },
            subtitle: {   // Body 1 Bold is used in Figma for this.
                fontFamily,
                fontSize: { base: '1rem' },
                fontWeight: 600,
                lineHeight: { base: '1.5rem' },
                letterSpacing: { base: '0.005rem' },
            },
            body1: {   // Body 1 Regular is used in Figma for this.
                fontFamily,
                fontSize: { base: '1rem' },
                fontWeight: 400,
                lineHeight: { base: '1.5rem' },
                letterSpacing: { base: '0.005rem' },
            },
            body2: {
                fontFamily,
                fontSize: { base: '0.875rem' },
                fontWeight: 400,
                lineHeight: { base: '1.25rem' },
                letterSpacing: { base: '0.00219rem' },
            },
            body3: {
                fontFamily,
                fontSize: { base: '0.75rem' },
                fontWeight: 400,
                lineHeight: { base: '1rem' },
            },
            caption: {    // Body 4 is used in Figma for this.
                fontFamily,
                fontSize: { base: '0.6875rem' },
                fontWeight: 400,
                lineHeight: { base: '1rem' },
                letterSpacing: { base: '0.00344rem' },
            },
            buttonLarge: {
                fontFamily,
                fontSize: { base: '1.125rem' },
                fontWeight: 400,
                lineHeight: { base: '1.5rem' },
            },
            buttonSmall: {
                fontFamily,
                fontSize: { base: '1rem' },
                fontWeight: 400,
                lineHeight: { base: '1.25rem' },
            },
            link: {
                fontFamily,
                fontSize: { base: '1.25rem' },
                fontWeight: 400,
                lineHeight: { base: '1.5rem' },
            },
        },

        grid: {
            xs: 4,
            sm: 8,
            md: 8,
            lg: 12,
            xl: 12,
        },
    })
}


export default getTheme;
